module.exports = __webpack_public_path__ + "img/03.16be2b8b.jpg";